import {useState,  useEffect, useRef} from 'react';
import {getDecryptCookie, showToast, updateUTCDate} from '../common/app_common';
import {Title} from '../common/component_common.js';
import Button from 'react-bootstrap/Button';
import {BsFiles, BsTrash} from 'react-icons/bs';
import {getApiTokenIssueIssuer, delApiTokenName} from '../common/fetch_api/api_common';
import {AddToken} from './control_token/modals.js';
import {DecideWindow} from '../common/modal_common.js';
import '../common/css/control_token.css';

const PageControlToken = () => {

    const [update, setUpdate] = useState(false);

    const [tokenList, setTokenList] = useState(null);
    const [seletedName, setSeletedName] = useState('');

    const [modalAddToken, setModalAddToken] = useState(false);
    const closeModalAddToken = () => setModalAddToken(false);
    const showModalAddToken = () =>
    {
        setModalAddToken(true);
    };

    const [decideBody, setDecideBody] = useState(null);
    const [decideBtn, setDecideBtn] = useState('OK');
    const [modalDecide, setModalDecide] = useState(false);
    const closeModalDecide = () => setModalDecide(false);
    const showModalDecide = (name) =>
    {
        setSeletedName(name);
        setDecideBtn('Delete');
        setDecideBody(
            <div className='text-center'>
                <p>Would you like to delete this Token?</p>
            </div>
        );
        
        setModalDecide(true);
    }

    const onClickRemoveToken = (is) => {
        if( is )
        {
            Promise.resolve( delApiTokenName(seletedName) )
            .then( done => {
                runUpdate();
            });
        }
    }

    const onClickCopyToken = (token) => {
        if (typeof (navigator.clipboard) == 'undefined')
        {
            let textArea = document.createElement("textarea");
            textArea.value = token;
            textArea.style.position = "fixed";
            document.body.appendChild(textArea);
            textArea.select();

            try
            {
                let successful = document.execCommand('copy');
                let msg = successful ? 'Copied' : 'Not Copied';
                showToast(msg, 'success');
            }
            catch (err)
            {
                showToast('Not Copied: ', 'warning');
            }

            document.body.removeChild(textArea)
            return;
        }

        navigator.clipboard.writeText(token).then(function()
        {
            showToast(`Copied`, 'success');
        }, function (err)
        {
            showToast('Not Copied', 'warning');
        });
    }

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() => {
        const getName = getDecryptCookie('using');
        
        Promise.resolve( getApiTokenIssueIssuer(getName) )
        .then( issueArr => {

            setTokenList( issueArr.map( (issue) => (
                <tr key={issue.token}>
                    <td>{issue.name}</td>
                    <td>{issue.token}</td>
                    <td className={`${(issue.expires - (new Date().getTime()/1000)) <= 0 ? 'text-warning' : ''}`} >{updateUTCDate(new Date(issue.expires*1000))}</td>
                    <td>
                        <Button variant="secondary" className="btn btn-icon" onClick={() => {onClickCopyToken(issue.token)}}><BsFiles/></Button>
                    </td>
                    <td>
                        <Button variant={'danger'} className="btn btn-icon" onClick={() => {showModalDecide(issue.name)}}><BsTrash/></Button>
                    </td>
                </tr>
            )));
        });
    }, [update]);

    return (
        <>
            <Title title='Token'></Title>
            <div className="d-flex justify-content-end">
                <Button variant="primary" className="btn btn-sm me-2 mb-2" onClick={showModalAddToken}>Create Token</Button>
            </div>
            <div className="d-flex">
                <div className="section token-setting">
                    <div className="col-xxl-8 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Token</th>
                                    <th>Expires</th>
                                    <th>Copy</th>
                                    <th>Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tokenList}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {modalDecide&&<DecideWindow result={onClickRemoveToken} show={modalDecide} handleClose={closeModalDecide} body={decideBody} okButtonTxt={decideBtn}></DecideWindow>}
            {modalAddToken&&<AddToken curPermission={getDecryptCookie('type')} show={modalAddToken} handleClose={closeModalAddToken} update={runUpdate}></AddToken>}
        </>
    )
}

export default PageControlToken;